<template>
  <v-container class="fill-height pa-0" fluid>
    <v-data-table
      :headers="headers"
      :items="$store.state.prenotazioni_da_schedulare"
      style="width: 100%"
      height="calc(100vh - 200px)"
      :items-per-page="15"
      :search="search"
      no-results-text="Nessun risultato"
      no-data-text="Nessun dato disponibile"
      fixed-header
      :footer-props="{
        'items-per-page-options': [15, 25, 50, -1],
        'items-per-page-text': 'Elementi per pagina',
        'items-per-page-all-text': 'Tutti',
      }"
      class="mt-3"
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            label="Cerca"
            prepend-inner-icon="mdi-magnify"
            clearable
            hide-details
          ></v-text-field>

          <v-spacer></v-spacer>

          <v-btn
            v-blur
            fab
            small
            color="primary"
            @click="openAggiungiPrenotazione"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:[`item.giorni`]="{ item }">
        {{ getGiorni(item.giorni) }}
      </template>

      <template v-slot:[`item.ora_inizio`]="{ item }">
        {{ `${item.ora_inizio} - ${item.ora_fine}` }}
      </template>

      <template v-slot:[`item.periodi`]="{ item }">
        <v-chip color="rgba(0, 0, 0, 0.12)">
          {{ item.periodi.length }}
        </v-chip>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="openDettaglioPrenotazione(item, true)"
        >
          mdi-open-in-new
        </v-icon>
        <v-icon small class="mr-2" @click="openGeneratePrenotazione(item)">
          mdi-calendar-plus
        </v-icon>
        <v-icon
          small
          class="mr-2"
          @click="openDettaglioPrenotazione(item, false)"
          v-if="item.periodi.length == 0"
        >
          mdi-pencil
        </v-icon>
        <v-icon small @click="openModificaStatoTemplate(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>

    <v-dialog v-model="prenotazione_dialog" max-width="800px" persistent>
      <AggiungiVisualizzaTemplatePrenotazioni
        v-model="prenotazione_edit"
        ref="prenotazione_dialog"
        @close-dialog="closeDialog"
        @update-prenotazioni="$store.dispatch('getPrenotazioniDaSchedulare')"
      />
    </v-dialog>

    <!-- DIALOG GENERA PRENOTAZIONI -->
    <v-dialog
      v-model="prenotazione_dialog_generate"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title class="text-h6" style="justify-content: center"
          >Schedula le prenotazioni nel periodo:</v-card-title
        >
        <v-card-text>
          <v-row>
            <v-col cols="12" class="pb-0">
              <v-menu
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
                ref="menu"
                :return-value.sync="dates"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateRangeText"
                    label="Dalla data - alla data"
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    readonly
                    v-on="on"
                    :rules="
                      periodoGiàPresente != '' ? [periodoGiàPresente] : []
                    "
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dates"
                  range
                  :min="minDate"
                  first-day-of-week="1"
                  locale="it-IT"
                  ><v-btn
                    tile
                    color="success"
                    class="ml-auto"
                    small
                    @click="confirmDates()"
                    :disabled="dates.length != 2"
                  >
                    OK
                  </v-btn></v-date-picker
                >
              </v-menu>
            </v-col>
            <v-col cols="12" class="py-0">
              <p class="pt-4 mb-0">Ultimi 4 periodi schedulati:</p>
              <span v-for="(periodo, i) in periodiDaMostrare" :key="i">
                {{ formattedData(periodo.data_inizio) }} -
                {{ formattedData(periodo.data_fine) }}<br />
              </span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="closeDialog"> Annulla </v-btn>
          <v-btn
            color="primary"
            text
            @click="generatePrenotazione"
            :loading="prenotazione_dialog_generate_loading"
            :disabled="
              prenotazione_dialog_generate_loading ||
              dates.length != 2 ||
              periodoGiàPresente != ''
            "
          >
            Conferma
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG DELETE -->
    <v-dialog v-model="prenotazione_dialog_delete" max-width="500px" persistent>
      <v-card style="text-align: center">
        <v-card-title class="text-h5" style="justify-content: center"
          >Attenzione</v-card-title
        >
        <v-card-text class="pb-0">
          <span class="black--text text-subtitle-1">
            Sei sicuro di voler cancellare il template
            <b>{{ prenotazione_delete["id_template"] }}</b
            >?
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="closeDialog"> Annulla </v-btn>
          <v-btn
            color="primary"
            text
            @click="modificaStatoPrenotazione"
            :loading="prenotazione_dialog_delete_loading"
            :disabled="prenotazione_dialog_delete_loading"
          >
            Conferma
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
  
  <script>
import AggiungiVisualizzaTemplatePrenotazioni from "../components/AggiungiVisualizzaTemplatePrenotazioni.vue";

export default {
  data: () => ({
    search: "",
    loading: false,
    prenotazione_dialog: false,
    prenotazione_dialog_delete: false,
    prenotazione_dialog_delete_loading: false,
    prenotazione_dialog_generate: false,
    prenotazione_dialog_generate_loading: false,
    prenotazione_edit: {},
    prenotazione_delete: {},
    prenotazione_generate: {},
    prenotazione_edit_default: {
      id_cliente: null,
      id_user: "",
      id_comparto: null,
      giorni: [],
      fascia: null,
      id_tipo_scarico: null,
      id_vettore: "",
      rag_soc_vettore: "",
      nome_riferimento_vettore: "",
      telefono_riferimento_vettore: "",
      email_riferimento_vettore: "",
      banali: "",
      riferimento_documento: "",
      mittente: "",
      note: "",
      indicazioni_scarico: "",
      data_ultima_modifica: "",
      user_ultima_modifica: "",
      stato: "",
      periodi: [],
    },
    dates: [],
    current_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10),
    dateRangeText: "",
    periodoGiàPresente: "",
    headers: [
      {
        text: "Codice",
        value: "id_template",
      },
      {
        text: "Cliente",
        value: "rag_soc_cliente",
      },
      {
        text: "Comparto",
        value: "category",
      },
      {
        text: "Tipo scarico",
        value: "tipo_scarico",
      },
      {
        text: "Giorni",
        value: "giorni",
      },
      {
        text: "Fascia",
        value: "ora_inizio",
      },
      {
        text: "Periodi schedulati",
        value: "periodi",
        align: "center",
      },
      { text: "Azioni", value: "actions", sortable: false, align: "center" },
    ],
    promise_clienti: null,
    promise_vettori: null,
    promise_scarichi: null,
    promise_comparti: null,
    promise_prenotazioni: null,
  }),
  components: {
    AggiungiVisualizzaTemplatePrenotazioni,
  },
  mounted() {
    this.$store.state.loaded = false;

    this.reloadDati();

    Promise.all([
      this.promise_clienti,
      this.promise_vettori,
      this.promise_scarichi,
      this.promise_comparti,
      this.promise_prenotazioni,
    ]).then(() => {
      this.$store.state.loaded = true;
      this.loading = false;
    });
  },
  methods: {
    reloadDati() {
      this.loading = true;

      this.promise_clienti = this.$store.dispatch("getClienti").catch((e) => {
        console.log(e);
      });
      this.promise_vettori = this.$store.dispatch("getVettori").catch((e) => {
        console.log(e);
      });
      this.promise_scarichi = this.$store
        .dispatch("getTipiScarico")
        .catch((e) => {
          console.log(e);
        });
      this.promise_comparti = this.$store.dispatch("getComparti").catch((e) => {
        console.log(e);
      });

      this.promise_prenotazioni = this.$store
        .dispatch("getPrenotazioniDaSchedulare")
        .catch((e) => {
          console.log(e);
        });
    },
    closeDialog() {
      this.prenotazione_dialog = false;
      this.prenotazione_dialog_delete = false;
      this.prenotazione_dialog_generate = false;
      this.prenotazione_edit = Object.assign(
        {},
        this.prenotazione_edit_default
      );
      this.prenotazione_delete = Object.assign(
        {},
        this.prenotazione_edit_default
      );
      this.prenotazione_generate = Object.assign(
        {},
        this.prenotazione_edit_default
      );
      this.prenotazione_edit.giorni = [];
      this.prenotazione_edit.tel_nascosto = "";
      this.prenotazione_edit.email_nascosta = "";
      this.dates = [];
      this.dateRangeText = "";
      this.periodoGiàPresente = "";
    },
    openAggiungiPrenotazione() {
      this.prenotazione_edit = Object.assign(
        {},
        this.prenotazione_edit_default
      );
      this.prenotazione_edit["giorni"] = [];
      this.prenotazione_edit["tel_nascosto"] = "";
      this.prenotazione_edit["email_nascosta"] = "";
      this.prenotazione_edit["nuova_prenotazione"] = true;
      this.prenotazione_edit["modifica_prenotazione"] = false;
      this.prenotazione_dialog = true;
    },
    openDettaglioPrenotazione(item, dettaglio) {
      this.prenotazione_edit = Object.assign({}, item);
      this.prenotazione_edit["nuova_prenotazione"] = false;
      this.prenotazione_edit["modifica_prenotazione"] = !dettaglio;
      // Formatto i dati
      if (this.prenotazione_edit["giorni"] == "") {
        this.prenotazione_edit["giorni"] = [];
      } else {
        this.prenotazione_edit["giorni"] = this.prenotazione_edit["giorni"]
          .split(",")
          .map((el) => Number(el));
      }
      this.prenotazione_edit["bancali"] =
        this.prenotazione_edit["bancali"].toString();

      if (this.prenotazione_edit["modifica_prenotazione"]) {
        this.prenotazione_edit["fascia"] = [
          this.prenotazione_edit["ora_inizio"],
          this.prenotazione_edit["ora_fine"],
        ];
      } else {
        this.prenotazione_edit[
          "fascia"
        ] = `${this.prenotazione_edit["ora_inizio"]} - ${this.prenotazione_edit["ora_fine"]}`;
      }

      //  Nascondo email
      var idEmail =
        this.prenotazione_edit.email_riferimento_vettore.indexOf("@");
      var lenToReplace =
        idEmail % 2 == 0 ? idEmail / 2 : Math.ceil(idEmail / 2);

      this.prenotazione_edit.email_nascosta =
        this.prenotazione_edit.email_riferimento_vettore.replace(
          this.prenotazione_edit.email_riferimento_vettore.slice(
            idEmail - lenToReplace,
            idEmail
          ),
          "*".repeat(lenToReplace)
        );

      //  Nascondo tel
      var len = this.prenotazione_edit.telefono_riferimento_vettore.length;
      if (len <= 3) {
        this.prenotazione_edit.tel_nascosto = "*".repeat(len);
      } else {
        this.prenotazione_edit.tel_nascosto =
          "*".repeat(len - 3) +
          this.prenotazione_edit.telefono_riferimento_vettore.slice(-3);
      }

      this.prenotazione_dialog = true;
    },
    openGeneratePrenotazione(item) {
      this.prenotazione_generate = Object.assign({}, item);
      this.prenotazione_dialog_generate = true;
    },
    generatePrenotazione() {
      this.prenotazione_dialog_generate_loading = true;

      this.axios
        .post(`${this.$store.state.endpoint}/genera-prenotazioni`, {
          id_template: this.prenotazione_generate.id_template,
          data_inizio: this.dates[0],
          data_fine: this.dates[1],
        })
        .then((res) => {
          if (res.data.prenotazioniDaStampare.length > 0) {
            this.$store
              .dispatch("openFilePrenotazione", {
                id_prenotazione: res.data.prenotazioniDaStampare,
              })
              .then(() => {
                this.$store.state.snackbar = true;
                this.$store.state.snackbar_text =
                  "Prenotazioni generate con successo!";
                this.$store.state.snackbar_color = "success";
              })
              .catch((e) => {
                console.log(e);
                this.$store.state.snackbar = true;
                this.$store.state.snackbar_text =
                  "Errore nella visualizzazione del documento. Le prenotazioni sono state comunque generate con successo";
                this.$store.state.snackbar_color = "error";
              })
              .finally(() => {
                this.prenotazione_dialog_generate_loading = false;
                this.closeDialog();
                this.$store.dispatch("getPrenotazioniDaSchedulare");
              });
          } else {
            this.prenotazione_dialog_generate_loading = false;
            this.$store.state.snackbar = true;
            this.$store.state.snackbar_text =
              "Non è stata generata alcuna prenotazione.";
            this.$store.state.snackbar_color = "success";
            this.closeDialog();
            this.$store.dispatch("getPrenotazioniDaSchedulare");
          }
        })
        .catch((e) => {
          this.$store.state.snackbar_text =
            "Non è stato possibile generare le prenotazioni";

          if (
            e.response &&
            e.response.data &&
            e.response.data.message &&
            typeof e.response.data.message === "string"
          ) {
            this.$store.state.snackbar_text += ": " + e.response.data.message;
          } else {
            this.$store.state.snackbar_text +=
              ". Verifica la connessione internet o riprova più tardi";
          }

          this.$store.state.snackbar = true;
          this.$store.state.snackbar_color = "error";
          this.prenotazione_dialog_generate_loading = false;
          console.log("Errore genera prenotazioni", e);
        })
    },
    openModificaStatoTemplate(item) {
      this.prenotazione_delete = Object.assign({}, item);
      this.prenotazione_dialog_delete = true;
    },
    modificaStatoPrenotazione() {
      this.prenotazione_dialog_delete_loading = true;

      var params = {
        id_template: this.prenotazione_delete.id_template,
      };

      this.axios
        .delete(
          `${
            this.$store.state.endpoint
          }/template-prenotazioni?${new URLSearchParams(params).toString()}`
        )
        .then(() => {
          this.$store.state.snackbar = true;

          this.$store.state.snackbar_text = `Template eliminato con successo!`;
          this.$store.state.snackbar_color = "success";

          this.$store.dispatch("getPrenotazioniDaSchedulare");
          this.closeDialog();
        })
        .catch((e) => {
          this.$store.state.snackbar_text = `Non è stato possibile eliminare il template`;

          if (
            e.response &&
            e.response.data &&
            e.response.data.message &&
            typeof e.response.data.message === "string"
          ) {
            this.$store.state.snackbar_text += ": " + e.response.data.message;
          } else {
            this.$store.state.snackbar_text +=
              ". Verifica la connessione internet o riprova più tardi";
          }

          this.$store.state.snackbar = true;
          this.$store.state.snackbar_color = "error";
          console.log("Errore template", e);
        })
        .finally(() => {
          this.prenotazione_dialog_delete_loading = false;
        });
    },
    getTipoScaricoFromId(id) {
      if (
        this.$store.state.tipi_scarico &&
        this.$store.state.tipi_scarico.length != 0
      ) {
        return this.$store.state.tipi_scarico.filter(
          (el) => el["id_tipo_scarico"] == id
        )[0];
      }

      return null;
    },
    getGiorni(giorni) {
      var value = "";

      giorni.split(",").forEach((el) => {
        switch (el) {
          case "1":
            value += "Lun, ";
            break;
          case "2":
            value += "Mar, ";
            break;
          case "3":
            value += "Mer, ";
            break;
          case "4":
            value += "Gio, ";
            break;
          case "5":
            value += "Ven, ";
            break;
          default:
            break;
        }
      });

      return value.trim().slice(0, -1);
    },
    formattedData(data) {
      return new Date(data).toLocaleDateString();
    },
    confirmDates() {
      if (this.$refs.menu != undefined) {
        this.$refs.menu.save(this.dates);
      }

      if (this.dates.length == 2) {
        this.dateRangeText = `${new Date(
          this.dates[0]
        ).toLocaleDateString()} - ${new Date(
          this.dates[1]
        ).toLocaleDateString()}`;
      }

      this.periodoGiàPresente = "";
      this.prenotazione_generate.periodi.forEach((el) => {
        if (
          (el.data_inizio == this.dates[0] && el.data_fine == this.dates[1]) ||
          (this.dates[0] >= el.data_inizio &&
            this.dates[0] <= el.data_fine &&
            this.dates[1] >= el.data_inizio &&
            this.dates[1] <= el.data_fine)
        ) {
          this.periodoGiàPresente = "Periodo già schedulato";
        } else if (
          (this.dates[0] >= el.data_inizio && this.dates[0] <= el.data_fine) ||
          (this.dates[1] >= el.data_inizio && this.dates[1] <= el.data_fine)
        ) {
          this.periodoGiàPresente = "Periodo parzialmente schedulato";
        }
      });
    },
  },
  computed: {
    minDate() {
      if (this.dates.length == 1) {
        return new Date(this.dates[0]).toISOString().slice(0, 10);
      }
      return this.current_date;
    },
    periodiDaMostrare() {
      if (
        this.prenotazione_generate.periodi &&
        this.prenotazione_generate.periodi.length > 0
      ) {
        return this.prenotazione_generate.periodi.slice(
          Math.max(this.prenotazione_generate.periodi.length - 4, 0)
        );
      }
      return [];
    },
  },
};
</script>
  
  <style scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>